<div class="row">
    <div class="inner vibrationInner col-md-2" style="display:inline-flex !important; vertical-align: top; margin-right: 98px;" *ngFor="let param of barChartParameters">
        <ng-container *ngIf="barchartloading; else barchartTemplate">
            <div class="spinner-container">
                <div class="spinner-border text-primary" role="status"></div>

            </div>

        </ng-container>

        <ng-template #barchartTemplate>
            <div class="" style="border:solid 0px;text-align:center; justify-content: space-between;">
                <div class="heading" style="margin-bottom: 40px;">{{ param.name }}</div>
                <div style="margin-left: 66px;">
                    <!-- <mat-slide-toggle [checked]="param.value === '1' ? true : false" [ngClass]="{ 'disabled-toggle': true }" style="transform: rotate(90deg);"></mat-slide-toggle> -->
                    <div [matTooltip]="param.value === '1'?'ON':'OFF'" [ngStyle]="param.value === '1' ? {'background-color':'#ff2a1b'} : {'background-color':'#83f10d'}" style="border-radius: 50%; border: none; width: 50px; height: 50px;"></div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
